import { render } from "./SpotlightLinks.vue?vue&type=template&id=4cdfbb19&scoped=true"
import script from "./SpotlightLinks.vue?vue&type=script&lang=js"
export * from "./SpotlightLinks.vue?vue&type=script&lang=js"

import "./SpotlightLinks.vue?vue&type=style&index=0&id=4cdfbb19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdfbb19"]])

export default __exports__